import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import "../src/styles/global.scss";

function App() {
  return (
    <Router>
      <Routes />
    </Router>
  );
}

export default App;
